(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function reveal(root) {
    var els = root.querySelectorAll('.el-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (e) { io.observe(e); });
  }

  function counters(root) {
    root.querySelectorAll('[data-el-count]:not([data-done])').forEach(function (el) {
      var m = (el.textContent || '').trim().match(/^(\d[\d,]*)(\D*)$/);
      if (!m) return;
      el.setAttribute('data-done', '1');
      var target = parseInt(m[1].replace(/,/g, ''), 10), suffix = m[2], comma = m[1].indexOf(',') > -1;
      if (reduce || !('IntersectionObserver' in window)) return;
      var fmt = function (n) { return (comma ? n.toLocaleString('en-US') : n) + suffix; };
      el.textContent = fmt(0);
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        var t0 = performance.now(), dur = 1800;
        (function tick(t) {
          var p = Math.min((t - t0) / dur, 1), e = 1 - Math.pow(1 - p, 3);
          el.textContent = fmt(Math.round(target * e));
          if (p < 1) requestAnimationFrame(tick);
        })(t0);
      }, { threshold: 0.6 });
      io.observe(el);
    });
  }

  function tilt(root) {
    if (!fine || reduce) return;
    root.querySelectorAll('.el-mood:not([data-tilt])').forEach(function (card) {
      card.setAttribute('data-tilt', '1');
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.transform = 'rotateY(' + ((x - 0.5) * 10) + 'deg) rotateX(' + ((0.5 - y) * 10) + 'deg) translateY(-6px)';
        card.style.setProperty('--gx', x * 100 + '%');
        card.style.setProperty('--gy', y * 100 + '%');
      });
      card.addEventListener('pointerleave', function () { card.style.transform = ''; });
    });
  }

  function parallax(root) {
    if (!fine || reduce) return;
    root.querySelectorAll('.el-hero:not([data-px])').forEach(function (hero) {
      hero.setAttribute('data-px', '1');
      var media = hero.querySelector('.el-hero__media');
      if (!media) return;
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        media.style.transform = 'translate(' + (x * -22) + 'px,' + (y * -22) + 'px)';
      });
      hero.addEventListener('pointerleave', function () { media.style.transform = ''; });
    });
  }

  function init(root) { root = root || document; reveal(root); counters(root); tilt(root); parallax(root); }
  if (window.__eloriaHomeInit) return;
  window.__eloriaHomeInit = true;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
